import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appSetBackgroundColor]'
})
export class SetBackgroundColorDirective {
  @Input('appSetBackgroundColor') backgroundColor: string;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    if(this.backgroundColor)
      this.el.nativeElement.style.backgroundColor = this.backgroundColor;
  }
}
